import { qsa } from "@meduza/dom";

import { section } from "@/glow";
import playButtonBlock from "@/lib/play-button-block";
import { animateImageHero, shouldAnimate } from "@/lib/animation";

const selectors = {
  playButtonVideo: "[data-play-button-block-video]",
  playButtonBlock: ".play-button-block",
};

section("image-hero", {
  onLoad() {
    const playButtonVideos = qsa(selectors.playButtonVideo, this.container);

    if (playButtonVideos.length) {
      this.playButtons = playButtonVideos.map(block =>
        playButtonBlock(block.closest(selectors.playButtonBlock))
      );
    }

    if (shouldAnimate(this.container)) {
      this.animateImageHero = animateImageHero(this.container);
    }
  },

  onUnload() {
    this.playButtons && this.playButtons.forEach(button => button.unload());
    this.animateImageHero?.destroy();
  },
});
